export default "__VITE_ASSET__70b29c6d__"